/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/
 
/********************************************************************
 * Base configuration
 * All environments inherit this and override the neccesary options.
 ********************************************************************/
'use strict';

const config = {
    "app" : {
        "zendeskBasePathEN": "https://cambridgeonehelptest.cambridge.org/hc/en-gb",
        "zendeskBasePathES": "https://cambridgeonehelptest.cambridge.org/hc/es-es",
        "ieltsConfig": {
            'microEntitlementFeatureKeys': {
                DEFAULT: "testAndFeedback",
                TEST_AND_FEEDBACK: "testAndFeedback",
                FEEDBACK: "feedback",
                LESSON: "lesson"
            },
            "OrderStatus" : {
                PENDING_STATUS: 1,
                PROCESSING_STATUS: 2,
                DELIVERED_STATUS: 3,
                WAITING_PAYMENT_STATUS: 4,
                PAYMENT_RECEIVED_STATUS: 5,
                PAYMENT_DECLINED_STATUS: 6,
                PAYMENT_CANCELLED_STATUS: 8,
                REJECTED_STATUS: 12,
                ACCEPTED_BY_SAP: 11,
                PAYMENT_REFUND_APPROVED: 9,
                TIMEOUT_ERROR: "TIMEOUT_ERROR"
            },
            'miniTestTypes': {
                'd6bd099e-f6df-6b4a-483a-92972419b0e5': {
                    items: 30,
                    price: 7.99,
                    time: '40',
                    key: 'IELTSi30',
                    title: 'IELTSi 30',
                    sapId: '2800465042'
                },
                '10bd099f-0670-b9c8-5b68-4827b30ffaf8': {
                    items: 8,
                    price: 1.99,
                    time: '15',
                    key: 'IELTSi8',
                    title: 'IELTSi 8',
                    sapId: '2800484745'
                },
                '5abd099e-ff99-c2a7-4497-4e25f8531060': {
                    items: 4,
                    price: 0.99,
                    time: '5',
                    key: 'IELTSi4',
                    title: 'IELTSi 4',
                    sapId: '2800484748'
                }
            },
            'skillType': {
                'ielts_pe': {
                    'types': {
                        'lessons': {
                            desc_key: 'IELTS_READING.LESSONS',
                            sapId: '2800514880',
                            defaultPrice: 1.99,
                        },
                        'allLessons': {
                            defaultPrice: 4.99,
                            desc_key: 'IELTS_READING.ALLLESSONS',
                            sapId: '2800503895',
                        },
                        'test-pack': {
                            desc_key: 'IELTS_READING.TEST_PACK'
                        },
                        'research': {
                            desc_key: 'IELTS_READING.RESEARCH'
                        }
                    }

                },
                'ielts_listening': {
                    'types': {
                        'lessons': {
                            desc_key: 'IELTS_LISTENING.LESSONS',
                            sapId: '2800515443',
                            defaultPrice: 1.99,
                        },
                        'allLessons': {
                            defaultPrice: 4.99,
                            desc_key: 'IELTS_LISTENING.ALLLESSONS',
                            sapId: '2800503896',
                        },
                        'test-pack': {
                            desc_key: 'IELTS_LISTENING.TEST_PACK'
                        },
                        'research': {
                            desc_key: 'IELTS_LISTENING.RESEARCH'
                        }
                    }
                },
                'ielts_writing': {
                    'types': {
                        'lessons': {
                            desc_key: 'IELTS_WRITING.LESSONS',
                            sapId: '2800509800',
                            defaultPrice: 1.99,
                        },
                        'allLessons': {
                            defaultPrice: 10.99,
                            desc_key: 'IELTS_WRITING.ALLLESSONS',
                            sapId: '2800503889'
                        },
                        'test-pack': {
                            desc_key: 'IELTS_WRITING.TEST_PACK'
                        },
                        'research': {
                            desc_key: 'IELTS_WRITING.RESEARCH'
                        }
                    }
                },
                'ielts_speaking': {
                    'types': {
                        'lessons': {
                            desc_key: 'IELTS_SPEAKING.LESSONS',
                            sapId: '2800509800',
                            defaultPrice: 1.99,
                        },
                        'allLessons': {
                            defaultPrice: 10.99,
                            desc_key: 'IELTS_SPEAKING.ALLLESSONS'
                        },
                        'test-pack': {
                            desc_key: 'IELTS_SPEAKING.TEST_PACK'
                        },
                        'research': {
                            desc_key: 'IELTS_SPEAKING.RESEARCH'
                        }
                    }

                }
            }
        },
        "classLimit" : {
            "componentLosDefaultCount": 700,
            "classLosLimit": 4500,
            "classStudentLimit": 100
        }
    }
};

module.exports = config;
